import { render, staticRenderFns } from "./BookingItemModal.vue?vue&type=template&id=2d016912&"
import script from "./BookingItemModal.vue?vue&type=script&lang=js&"
export * from "./BookingItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports